function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.692 2.453)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-7.638 -8.507)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.535 5.974)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(19.158 6.406)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M2.5,5.831V4.165H.833a.833.833,0,1,1,0-1.666H2.5V.833a.833.833,0,1,1,1.666,0V2.5H5.831a.833.833,0,0,1,0,1.666H4.165V5.831a.833.833,0,0,1-1.666,0Z",
  transform: "translate(0 0)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 19,
  height: 19,
  transform: "translate(0.411 0.079)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.966, 0.259, -0.259, 0.966, 5.528, 3.275)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M1.336.06A1.806,1.806,0,0,1,1.75.007q4.656-.014,9.313,0a1.79,1.79,0,0,1,1.731,1.732V8.085l0,.051a.5.5,0,0,1-.1.282A.6.6,0,0,1,11.8,8.5a.582.582,0,0,1-.161-.31.544.544,0,0,1-.009-.1V1.75a.6.6,0,0,0-.577-.582c-3.1-.01-6.2,0-9.294,0a.6.6,0,0,0-.582.577V2.979l0,.051a.5.5,0,0,1-.1.282.6.6,0,0,1-.886.078.584.584,0,0,1-.161-.31.544.544,0,0,1-.009-.1A4.324,4.324,0,0,1,.234.91,1.774,1.774,0,0,1,1.294.071Z",
  transform: "translate(0 0)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.429 13.209)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M52.013,93.845a.53.53,0,0,1,.081.008.606.606,0,0,1,.325.972.6.6,0,0,1-.422.182H50.835a.581.581,0,1,1,0-1.161C51.228,93.845,51.62,93.84,52.013,93.845Z",
  transform: "translate(-50.258 -93.843)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.526 13.209)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M52.013,93.845a.607.607,0,0,1,.52.8.575.575,0,0,1-.537.358H50.835a.6.6,0,0,1-.537-.8.6.6,0,0,1,.537-.358C51.228,93.845,51.621,93.84,52.013,93.845Z",
  transform: "translate(-50.26 -93.843)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.623 13.209)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M78.636,93.845a.54.54,0,0,1,.081.008.6.6,0,0,1,.325.972.6.6,0,0,1-.422.182H77.459a.6.6,0,0,1-.537-.8.6.6,0,0,1,.537-.358C77.851,93.845,78.244,93.84,78.636,93.845Z",
  transform: "translate(-76.883 -93.843)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.291 7.397)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M67.641,67.947a1.786,1.786,0,0,1,1.731,1.732q.008,2.624,0,5.248a1.79,1.79,0,0,1-1.731,1.732q-4.656.014-9.313,0A1.781,1.781,0,0,1,56.6,74.926q-.008-2.624,0-5.248a1.783,1.783,0,0,1,1.731-1.732Q62.985,67.932,67.641,67.947Zm-9.3,1.162a.6.6,0,0,0-.582.57c-.027,1.745,0,3.491,0,5.236a.6.6,0,0,0,.577.581c3.1.01,6.2,0,9.294,0a.6.6,0,0,0,.582-.577c.005-1.743,0-3.486,0-5.229a.6.6,0,0,0-.577-.581C64.536,69.1,61.438,69.108,58.34,69.108Z",
  transform: "translate(-56.593 -67.94)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.028 9.145)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M79.214,89.852a1.184,1.184,0,0,1,1.138,1.138,3.048,3.048,0,0,1-.061.982,1.18,1.18,0,0,1-1.077.783c-.4,0-.8,0-1.194,0a1.188,1.188,0,0,1-1.152-1.138,3.047,3.047,0,0,1,.061-.982,1.18,1.18,0,0,1,1.077-.783Q78.61,89.849,79.214,89.852Zm-1.185,1.161v.581h1.161v-.581Z",
  transform: "translate(-76.859 -89.85)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.103 9.727)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M88.54,90.852a.581.581,0,0,1-.03,1.161H84.445a.581.581,0,0,1,0-1.161h4.1Z",
  transform: "translate(-83.865 -90.852)"
}))))));

var SvgAddCard = function SvgAddCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.411,
    height: 19,
    viewBox: "0 0 25.411 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addCard.1d02d16b.svg";
export { ForwardRef as ReactComponent };